import { useMutation } from '@apollo/client'
import { ResendInvitation, ResendInvitationVariables } from '../../types'
import { RESEND_INVITATION } from './operations'

export const useResendUserInvitation = () =>
  useMutation<ResendInvitation, ResendInvitationVariables>(RESEND_INVITATION)
